import { present } from 'shared/presenters/presenter'
import { translatablePresenter } from 'shared/presenters/translatablePresenter'
import { Optional_Extras } from 'shared/presenters/graphqlTypes'

export class OptionalExtraPresenter extends translatablePresenter(
  present<Optional_Extras>()
) {
  name = () => this.translateField('name')
}
